<template>
  <div>
    <div ref="googleMap" class="google-map rounded shadow"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';

export default {
  props: {
    mapConfig:{
      type: Object,
      required:false
    },
    apiKey:{
      type: String,
      required:false
    },
    markers:{
      type: Array,
      required:false
    }
  },

  data() {
    return {
      google: null,
      map: null,
      dataMarkers: []
    };
  },

  async mounted() {
    const googleMapApi = await new Loader({
       apiKey: this.apiKey
    })
    

    this.google = await googleMapApi.load()
    if (this.google) {
      this.initializeMap();
    }
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
      this.fitMap();
      this.$nextTick(() => {
        this.$emit('ready', this.map)
      })
    },
    fitMap() {
      var bounds = new this.google.maps.LatLngBounds();
      this.markers.forEach(marker => bounds.extend(marker.position))
      this.map.fitBounds(bounds);
 }
  }
};
</script>

<style scoped>
.google-map {
  min-height: 330px;
}
</style>
